import { Link } from "react-router-dom";
import { Crown, Search, Zap } from "lucide-react";
import { useUsage } from "@/lib/usage";

export default function PlanBadge() {
  const { isPaid, isTrial, isStarter, trialDaysLeft, used, limit, loading, plan } = useUsage();
  if (loading) return null;
  if (plan === "research") {
    return (
      <Link to="/billing" data-testid="header-research-badge" title="SnapList Research — manage plan"
        className="inline-flex h-9 shrink-0 items-center gap-1 rounded-full max-sm:w-9 max-sm:justify-center max-sm:px-0 border border-[#0053DA]/30 bg-blue-50 px-3 text-[11px] font-bold uppercase tracking-wider text-[#0053DA] transition-colors hover:bg-blue-100">
        <Search className="h-3.5 w-3.5" /><span className="hidden sm:inline">Research</span>
      </Link>
    );
  }
  if (isStarter) {
    const left = Math.max(0, (limit || 0) - used);
    const tone = left === 0 ? "bg-rose-500 text-white hover:bg-rose-600"
      : left <= 20 ? "border border-amber-300 bg-amber-50 text-amber-700 hover:bg-amber-100"
      : "border border-[#0053DA]/30 bg-blue-50 text-[#0053DA] hover:bg-blue-100";
    return (
      <Link to="/billing" data-testid="header-starter-badge" data-left={left} title="SnapList Starter — manage plan"
        className={`inline-flex h-9 shrink-0 items-center gap-1 rounded-full max-sm:w-9 max-sm:justify-center max-sm:px-0 px-3 text-[11px] font-bold uppercase tracking-wider transition-colors ${tone}`}>
        <Zap className="h-3.5 w-3.5" /><span className="hidden sm:inline">Starter<span data-testid="header-starter-left">&nbsp;· {left} left</span></span>
      </Link>
    );
  }
  if (isTrial) {
    const urgent = trialDaysLeft <= 2;
    return (
      <Link to="/billing" data-testid="header-trial-badge" title="Free Pro trial — tap to keep Pro"
        className={`inline-flex h-9 shrink-0 items-center gap-1 rounded-full max-sm:w-9 max-sm:justify-center max-sm:px-0 px-3 text-[11px] font-bold uppercase tracking-wider transition-colors ${urgent ? "bg-rose-500 text-white hover:bg-rose-600" : "border border-amber-300 bg-amber-50 text-amber-700 hover:bg-amber-100"}`}>
        <Crown className="h-3.5 w-3.5" /><span className="hidden sm:inline">Trial&nbsp;· {trialDaysLeft}d left</span>
      </Link>
    );
  }
  return isPaid ? (
    <Link to="/billing" data-testid="header-pro-badge" title="SnapList Pro — manage plan"
      className="inline-flex h-9 shrink-0 items-center gap-1 rounded-full max-sm:w-9 max-sm:justify-center max-sm:px-0 bg-gradient-to-r from-amber-400 to-amber-500 px-3 text-[11px] font-bold uppercase tracking-wider text-white shadow-sm transition-transform hover:scale-105" aria-label="SnapList Pro, manage plan">
      <Crown className="h-3.5 w-3.5" /><span className="hidden sm:inline">Pro</span>
    </Link>
  ) : (
    <Link to="/billing" data-testid="header-go-pro-link" title="Upgrade to SnapList Pro"
      className="inline-flex h-9 shrink-0 items-center gap-1 rounded-full max-sm:w-9 max-sm:justify-center max-sm:px-0 border border-amber-300 bg-amber-50 px-3 text-[11px] font-bold uppercase tracking-wider text-amber-700 transition-colors hover:bg-amber-100">
      <Crown className="h-3.5 w-3.5" /><span className="hidden sm:inline">Go Pro</span>
    </Link>
  );
}
